import { render, staticRenderFns } from "./table-settings-positions.vue?vue&type=template&id=7b85874a&scoped=true&"
import script from "./table-settings-positions.vue?vue&type=script&lang=js&"
export * from "./table-settings-positions.vue?vue&type=script&lang=js&"
import style0 from "./table-settings-positions.vue?vue&type=style&index=0&id=7b85874a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85874a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b85874a')) {
      api.createRecord('7b85874a', component.options)
    } else {
      api.reload('7b85874a', component.options)
    }
    module.hot.accept("./table-settings-positions.vue?vue&type=template&id=7b85874a&scoped=true&", function () {
      api.rerender('7b85874a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/data-table/table-settings-positions.vue"
export default component.exports